// utils
import { safeGetOr } from 'utils/fp'
import { flatMap, has, isArray } from 'lodash'
import { find, get as getFp, isEmpty, pipe } from 'lodash/fp'

export const getValuesFromOptions = (options) => (options || []).map(({ value }) => value)
export const getOptionsByEntity = (options, entity) => (options || []).filter((option) => option.entity === entity)
export const toOption = (value) => {
  if (value) {
    return { label: value, value }
  }
}
export const getValueFromOption = (option) => option?.value
export const getOptionFromValue = (value) => ({ label: value, value: value })
export const getOptionByValue = (value, options) => options.find((option) => option.value === value)
export const getOptionsByValue = (values, options) => values?.map((option) => getOptionByValue(option, options))
export const getOptionFromData = (data) => (data ? { label: data.name, value: data.id } : {})

export const getOptionByValueFlat = (value, options) => {
  const flatOptions = flatMap(options, (item) => {
    if (has(item, 'options') && isArray(item.options)) {
      return item.options
    }
    return item
  })

  return getOptionByValue(value, flatOptions)
}

export const getOptionsWithClearValue = (options) => {
  const clearValue = [{ label: '', value: null, entity: '' }]

  return clearValue.concat(options)
}

export const getValueFromField = (data, fields, fieldName) => {
  if (data) {
    return pipe(
      find((field) => field.name === fieldName),
      safeGetOr([], 'options'),
      find((option) => option.id === data.value),
      safeGetOr(data.value, 'value')
    )(fields)
  }
}

export const getOptionFromFields = (fields, fieldName, optionValue) => {
  if (isEmpty(fields)) {
    return
  }

  return pipe(
    find(({ name }) => name === fieldName),
    getFp('options'),
    find(({ value }) => value === optionValue),
    (option) => {
      if (option) {
        return { label: option.label, value: option.id }
      }
      return null
    }
  )(fields)
}
